module.exports = __webpack_public_path__ + "assets/img/travel-day41.66973989.png";